"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publishRaiseN2OTPIVRErrorEvent = exports.ModelbankUSDManagerInitializer = void 0;
/* eslint-disable no-console */
const types_1 = require("../../security/authoriser/types");
const ivr_1 = require("../../security/events/ivr");
Object.defineProperty(exports, "publishRaiseN2OTPIVRErrorEvent", { enumerable: true, get: function () { return ivr_1.publishRaiseN2OTPIVRErrorEvent; } });
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const USD_ERROR = 'USD initialization error';
const CHANNEL_CC = 'CC';
const PLATFORM_DESKTOP = 'DESKTOP';
class ModelbankUSDManagerInitializationError extends web_ui_framework_1.InitializerError {
    constructor(errorMessage, channel, platform) {
        const message = `[Channel: ${channel}. Platform: ${platform}] ${errorMessage}`;
        super(USD_ERROR, message);
    }
}
class ModelbankUSDManagerInitializer extends web_ui_framework_1.Initializer {
    constructor(eventBus, session, usdData) {
        super([eventBus]);
        this.authenticator = null;
        //TODO Fix this. Caused because circular dependencies
        this.setAuthenticator = (authenticator) => {
            this.authenticator = authenticator;
        };
        this.launch = () => {
            try {
                this.modelbankUSDManager = new web_ui_framework_1.ModelbankUSDManager({
                    setAgentClientData: () => {
                        return undefined;
                    },
                    refreshAgentToken: agentToken => {
                        const session = this.session.getInitialized();
                        const sessionData = session.getData();
                        session.updateData({ ...sessionData, agentToken });
                    },
                    invalidateSessionTokens: () => {
                        return undefined;
                    },
                    refreshSessionTokens: (accessToken, refreshToken) => {
                        const session = this.session.getInitialized();
                        const sessionData = session.getData();
                        sessionData && session.updateData({ ...sessionData, accessToken, refreshToken });
                        session.refresh();
                    },
                    notifyInteractionEnded: () => {
                        const authenticator = this.authenticator?.getInitialized();
                        authenticator && authenticator.logout();
                    },
                    RaiseN2InIvrSuccess: () => {
                        return undefined;
                    },
                    RaiseN2InIvrFailure: () => {
                        return undefined;
                    },
                    RaiseN2OTPInIvrSuccess: progressId => {
                        (0, ivr_1.publishRaiseN2OTPIVRSuccessEvent)({ type: types_1.ChallengeType.NONE, progressId });
                    },
                    RaiseN2OTPInIvrFailure: (errorType) => {
                        (0, ivr_1.publishRaiseN2OTPIVRErrorEvent)(errorType);
                    },
                    updateSignatureKeySuccess: () => {
                        return undefined;
                    },
                    updateSignatureKeyFailure: () => {
                        return undefined;
                    },
                    createPasswordOnboardingFinished: () => {
                        return undefined;
                    },
                    verifyDataInIvrSuccess: () => {
                        (0, ivr_1.publishVerifyDataInIvrSuccessEvent)(undefined);
                    },
                    verifyDataInIvrFailure: (errorType) => {
                        (0, ivr_1.publishVerifyDataInIvrFailureEvent)(errorType);
                    },
                });
                if (this.usdData) {
                    this.modelbankUSDManager.loadFromData(this.usdData);
                }
                return this.modelbankUSDManager;
            }
            catch (e) {
                throw new ModelbankUSDManagerInitializationError(e, CHANNEL_CC, PLATFORM_DESKTOP);
            }
        };
        this.usdData = usdData;
        this.session = session;
    }
}
exports.ModelbankUSDManagerInitializer = ModelbankUSDManagerInitializer;
//# sourceMappingURL=usd.initializer.js.map